import axios from "../axiosPlugin.js";

export const getAccountsReceivableVerifyService = data => {
  return axios({
    url: "/api/report/pdfAccountsReceivableVerify",
    method: "get",
    data: {
      data,
    },
  });
};
